// extracted by mini-css-extract-plugin
export default {"dlNotFoundComponentBox":"src-js-components-NotFoundComponentBox---dlNotFoundComponentBox---M2tuX"};